import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY } from "./apiRoutes";

interface UseGetPropertyDeleteStateProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
  communityId: string;
  id: string;
}

const getPropertyDeleteState = async (id: string, communityId: string) =>
  await axiosAuth.get(`${PROPERTY(communityId)}/${id}/delete-stats`);

const useGetPropertyDeleteState = ({
  queryParams,
  id,
  communityId
}: UseGetPropertyDeleteStateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["properties-delete-state", id],
    queryFn: () => getPropertyDeleteState(id, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyDeleteState;
